/**
 * Accordion functionality for collapsible panels (e.g. Achievements)
 */
export function initAccordion() {
  const accordions = document.querySelectorAll('.js-accordion');
  if (!accordions.length) {
    return;
  }

  accordions.forEach((accordion) => {
    const trigger = accordion.querySelector('.js-accordion-trigger');
    const panel = accordion.querySelector('.js-accordion-panel');

    if (!trigger || !panel) {
      return;
    }

    trigger.addEventListener('click', () => {
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        // Collapse
        trigger.setAttribute('aria-expanded', 'false');
        accordion.classList.remove('is-expanded');
        panel.hidden = true;
      } else {
        // Expand
        trigger.setAttribute('aria-expanded', 'true');
        accordion.classList.add('is-expanded');
        panel.hidden = false;
      }
    });
  });
}
